import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import { Address } from 'viem';

export interface EthereumPectraCompoundInfo {
  count: number;
  withdrawaddr: string;
  claimaddr: string;
  pubkeys: string[];
  signatures: string[];
  paramsSig: string;
  extradata: number;
  tips: number;
  stake: number;
}

export const createOrder_mutationFn = (variables: {
  withdrawaddr: Address;
  claimaddr: Address;
  count: number;
  amount: number;
}) => {
  return request.post<ResponseObject<EthereumPectraCompoundInfo>>(
    '/api/v1/eth2/order/add/compound',
    {
      claim: variables.claimaddr,
      withdraw: variables.withdrawaddr,
      count: variables.count,
      amount: variables.amount,
    }
  );
};
